import { TThunkAction } from '../../types/redux/thunk';
import { ERooms } from '../../types/rooms';
import { setFieldsState } from '../fieldsState';
import { setFlatStats } from '../flatStats';

export function changeRooms(rooms: ERooms): TThunkAction {
  return async dispatch => {
    dispatch(setFieldsState({ rooms }));
    dispatch(setFlatStats());
  };
}
